import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/billing/tariffs'

class TariffDataService extends RestApiDataService {}

export default new TariffDataService(BASE_ENTITY_URL)
